import { render, staticRenderFns } from "./MultiUserChangeClient.vue?vue&type=template&id=5b338ae8"
import script from "./MultiUserChangeClient.vue?vue&type=script&lang=js"
export * from "./MultiUserChangeClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports